import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const DefaultRedirect: React.FC = (): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('new', { replace: true });
  }, [navigate]);

  return null;
};
